<template>
  <div class="d-flex align-items-center flex-column bg-custom mt-5">
    <div>
      <h1 class="text-white display-4">START YOUR ADVENTURE</h1>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.bg-custom {
  background: rgba(0, 0, 0, 0.479);
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  h1 {
    font-size: 20px;
  }
  a {
    font-size: 1rem;
  }
}
</style>